import { useEffect, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import useFetchFedwireFundTransaction from '@/hooks/useApi/useFetchFedwireFundTransaction';
import FedwireFundingTransactionInfo from './FedwireFundingTransactionInfo';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';
import { useBlockingLoader } from 'shared';
import { useAlertDialog } from '@/providers/AlertDialog.provider';

type FedwireFundingContainerProps = {
  TransactionID: string;
} & Omit<ComponentProps<typeof FedwireFundingTransactionInfo>, 'transaction'>;

export default function FedwireFundingContainer({
  TransactionID,
  Notes,
  jwt,
  ELinxRequestID = '',
  ...props
}: FedwireFundingContainerProps) {
  const { userSettings } = useUserSettingsProvider();
  const blockingLoader = useBlockingLoader();
  const alertDialog = useAlertDialog();
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const { fedwireFundTransaction, fetchFedwireFundTransaction } = useFetchFedwireFundTransaction({
    bearer: jwt,
  });

  useEffect(() => {
    blockingLoader.show();

    fetchFedwireFundTransaction({ TransactionID, Timezone: userSettings.timezone })
      .catch((error) =>
        alertDialog.error(tGlobal('error'), error instanceof Error ? error.message : tGlobal('errorOccurred')),
      )
      .finally(() => blockingLoader.hide());
  }, [TransactionID]);

  const transaction = fedwireFundTransaction;

  return (
    <div>
      {transaction && (
        <FedwireFundingTransactionInfo
          transaction={transaction}
          Notes={Notes}
          jwt={jwt}
          ELinxRequestID={ELinxRequestID}
          {...props}
        />
      )}
    </div>
  );
}
